import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import CorporateShell from "@/pages/CorporateShell";
import { PA_BASE } from "@/private-aviation/config";
import { PALayout } from "@/private-aviation/components/Layout";
import HomePage from "@/private-aviation/pages/HomePage";
import CharterPage from "@/private-aviation/pages/CharterPage";
import AircraftPage from "@/private-aviation/pages/AircraftPage";
import DestinationsPage from "@/private-aviation/pages/DestinationsPage";
import DestinationCityPage from "@/private-aviation/pages/DestinationCityPage";
import RoutePage from "@/private-aviation/pages/RoutePage";
import EmptyLegsPage from "@/private-aviation/pages/EmptyLegsPage";
import CorporatePage from "@/private-aviation/pages/CorporatePage";
import AboutPage from "@/private-aviation/pages/AboutPage";
import ContactPage from "@/private-aviation/pages/ContactPage";
import AdminPage from "@/private-aviation/pages/AdminPage";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, wheelMultiplier: 1 });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<CorporateShell />} />
          <Route path={`${PA_BASE}/admin`} element={<AdminPage />} />
          <Route path={PA_BASE} element={<PALayout />}>
            <Route index element={<HomePage />} />
            <Route path="charter" element={<CharterPage />} />
            <Route path="aircraft" element={<AircraftPage />} />
            <Route path="destinations" element={<DestinationsPage />} />
            <Route path="destinations/:city" element={<DestinationCityPage />} />
            <Route path="routes/:slug" element={<RoutePage />} />
            <Route path="empty-legs" element={<EmptyLegsPage />} />
            <Route path="corporate" element={<CorporatePage />} />
            <Route path="about" element={<AboutPage />} />
            <Route path="contact" element={<ContactPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
